export const allSelector = (state) => state?.jobReducer?.all;

export const getJobListByVoucher = (state) => state?.jobReducer?.jobList;

export const userListSelector = (state) => state?.jobReducer?.userList;

export const jobDetailSelector = (state) => state?.jobReducer?.detail;

// export const getIncomeByDate = (state) => state?.jobReducer?.income;
